<template>
  <footer class="bg-dark text-white text-center py-3 mt-4">
    <div class="mb-2">
      <router-link to="/services" class="text-white mx-2">服务</router-link> |
      <router-link to="/solutions" class="text-white mx-2">解决方案</router-link> |
      <router-link to="/about" class="text-white mx-2">关于我们</router-link> |
      <router-link to="/contact" class="text-white mx-2">联系我们</router-link>
    </div>

    <!-- 添加营业执照链接 -->
    <div>
      <a href="/businessLicense" class="text-white mx-2" target="_blank">
        营业执照：91420106MA4K3CPJ65
      </a>
    </div>

    <!-- 添加ICP备案信息并带公安图标 -->
    <div>
      <a href="https://beian.miit.gov.cn/" class="text-white mx-2" target="_blank" rel="noopener">
        鄂ICP备19013668号-1
        <img src="@/assets/police.png" alt="公安图标" style="width: 20px; height: 20px; margin-bottom: 4px; margin-left: 10px;" />
        鄂公网安备42010602004991号
      </a>
    </div>

    <!-- 公司版权信息 -->
    <div>
      Copyright © 武汉原牧欣网络科技有限公司 版权所有
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
